import React, { useMemo, useCallback, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { AgentSearchAutocomplete } from '@domain-group/fe-co-allhomes-autocomplete';
import { getLocalityLabel } from '../utils/localities';
import setDigitalData from '../utils/digital-data';
import * as styles from './filter-pane.style';
import { SORT_OPTIONS } from '../utils/sort-options';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fromLocality = locality => ({
  name: getLocalityLabel(locality),
  type: locality.type,
  id: locality.id
});
var FilterPane = _ref => {
  var localities = _ref.localities,
    sort = _ref.sort,
    performSearch = _ref.performSearch;
  useLayoutEffect(() => setDigitalData({
    searchTerm: localities.map(locality => "".concat(locality.name, " ").concat(locality.metaData.state).concat(locality.metaData.postcode ? " ".concat(locality.metaData.postcode) : '')).join('|'),
    sort: SORT_OPTIONS[sort] && SORT_OPTIONS[sort].value
  }), [localities, sort]);
  var locationValues = useMemo(() => localities.map(fromLocality), [JSON.stringify(localities)] // eslint-disable-line react-hooks/exhaustive-deps
  );
  var handleSuggestionSelect = useCallback(function () {
    var newValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    if (newValues.length === 1 && ['AGENT', 'AGENCY'].includes(newValues[0].type)) {
      window.location = newValues[0].url;
    } else {
      performSearch({
        localities: newValues,
        sort
      });
    }
  }, [performSearch, sort]);
  return ___EmotionJSX("div", null, ___EmotionJSX("div", {
    css: styles.container
  }, ___EmotionJSX(AgentSearchAutocomplete, {
    onSelectionChange: handleSuggestionSelect,
    initialSelectedItems: locationValues,
    css: styles.searchBar
  })));
};
FilterPane.propTypes = {
  localities: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    slug: PropTypes.string,
    type: PropTypes.string
  })),
  performSearch: PropTypes.func,
  sort: PropTypes.oneOf(['SOLD', 'SOLD_TOTAL', 'RENTED', 'RENTED_TOTAL']).isRequired
};
FilterPane.defaultProps = {
  localities: [],
  performSearch: () => {}
};
export default FilterPane;